var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid } from "@mui/material";
import VTButton from "../VTButton";
import VTTypography from "../VTTypography";
// Filter button render, for larger page sizes
export function VTFilterButton(_a) {
    var title = _a.title, icon = _a.icon, handleClick = _a.handleClick, disabled = _a.disabled, filterValue = _a.filterValue;
    return (_jsxs(Grid, __assign({ item: true, xs: 1, sx: {
            position: "relative",
            display: "flex",
            justifyContent: "center",
            height: "110px",
            marginRight: "100px",
            minWidth: "121px",
        } }, { children: [_jsx(VTTypography, __assign({ align: "center" }, { children: title })), _jsx(VTButton, __assign({ type: "avatar", disabled: disabled, onClick: handleClick, sx: __assign(__assign({ position: "absolute", bottom: 0, width: "82px", height: "82px", background: "linear-gradient(to bottom, #0ab5a7,#8e25fa)", color: "#ffffff", cursor: "pointer" }, (filterValue === title && { boxShadow: "0 0 15px #fff", fontSize: "1.4em" })), { "&:hover": {
                        boxShadow: "0 0 15px #fff",
                        fontSize: "1.4em",
                    } }) }, { children: icon }))] })));
}
